import { defineComponent, createElementBlock, openBlock, renderSlot, createElementVNode } from "vue";
const _hoisted_1 = { class: "overlay-layout" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowOverlay",
  emits: ["click"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true),
        createElementVNode("div", {
          "aria-hidden": "true",
          class: "overlay-backdrop",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click"))
        })
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowOverlay.vue2.js.map
